interface ErrorResponse {
  success: boolean;
  message: string;
  details: string;
  response?: {
    status: number;
    data?: string;
  };
}

export function errorHandler(error: any): ErrorResponse {
  // Log the error for debugging purposes
  console.error('Error occurred:', error);

  // Customize the error message based on the type of error
  if (error instanceof TypeError) {
    return {
      success: false,
      message: 'Network error. Please check your internet connection or the API endpoint.',
      details: error.message,
    };
  } else if (error instanceof SyntaxError) {
    return {
      success: false,
      message: 'Unexpected response format from the server.',
      details: error.message,
    };
  } else if (error.response) {
    // If the error has a response property (from Axios-like libraries)
    return {
      success: false,
      message: `Server responded with status ${error.response.status}`,
      details: error.response.data || error.message,
    };
  } else {
    return {
      success: false,
      message: 'An unexpected error occurred.',
      details: error.message,
    };
  }
}
